// @core/api/endpoints/project/create_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSprintRequest,
  SprintResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create sprint
 * Creates a new sprint with specified dates and optional goal. Sprints can be created in advance and filled with items during planning.
 */
export async function CreateSprint(
  project_id: string,
  data: CreateSprintRequest,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<SprintResponse>(requestPath, data, requestOptions);
}
